export const de = {
  about: "Über",
  email: "E-Mail",
  license: "Lizenz",
}
